<template>
  <Collapse simple class="collapse-warpper" value="1">
    <Panel name="1" class="collapse-panel">
      <span class="panel-title">{{initdata.title}}</span>
      <div slot="content">
        <!-- 复选框组 on-change 类似于watch-->
        <ul class="">
          <li class="service-li box" v-for="(item,index) in initdata.dataList" :key="index" @click.stop="showChild(item)">
            <i v-if="item.isSelect" class="iconfont icon-duoxuan1 xuan" @click.stop="selectService(item,index)"></i>
            <i v-else class="iconfont icon-duoxuankuang1 weixuan" @click.stop="selectService(item,index)"></i>
            <div :style="{color:item.isSelect?'#ff7b44':''}" class="box select-item">
              <div class="box" style="align-items: center">
                <img :src="item.headPic" class="head-pic"/>
                <div>{{item.label}}</div>
              </div>
              <div>{{item.number}}</div>
            </div>
              <ul v-if="item.children.length>0 && item.childShow" class="service-child">
                <li v-for="(_item,_index) in item.children" :key="_index" class="box service-child-li" @click.stop="showChild(_item)">
                  <i v-if="_item.isSelect" class="iconfont icon-duoxuan1 xuan" @click.stop="selectService(_item,index)"></i>
                  <i v-else class="iconfont icon-duoxuankuang1 weixuan" @click.stop="selectService(_item,index)"></i>
                  <div :style="{color:_item.isSelect?'#ff7b44':''}" class="box select-child-item">
                    <div>{{_item.label}}</div>
                    <div>{{_item.number}}</div>
                  </div>
                </li>
              </ul>
          </li>
        </ul>
      </div>
    </Panel>
  </Collapse>
</template>

<script>
import drop from "../dragger/drop";
export default {
  created() {
    this.oriChange = this._.debounce(this._oriChange, this.debounceTime, false);
  },
  mounted() {

  },
  props: ["initdata", "filterListIndex",'debounceTime'],
  // props:{
  //   initdata:{
  //     type:Object,
  //     default:{}
  //   },
  //   filterListIndex:{
  //     type:Number,
  //     default: 0
  //   },
  //   debounceTime:{
  //     type:String,
  //     default:''
  //   }
  // },
  data() {
    return {
      dataList: []
    };
  },
  watch:{
    initdata(newValue,oldValue) {
      console.log(this.initdata)
      this.initdata.dataList.forEach(item => {
        if (item.children.length) {
          item.children.forEach(_item => {
            if (this.dataList.indexOf(_item.id) >-1) {
              _item.isSelect = true
            }
          })
        }else {
          if (this.dataList.indexOf(item.id) >-1) {
            item.isSelect = true
          }
        }
      })
    }
  },
  methods: {
    /* 复选组勾选装填改变 */
    _oriChange() {
      this.$emit("event", {
        fn: "addOriChange",
        params: {
          selectedIndex: this.dataList,
          filterListIndex: this.filterListIndex
        }
      });
    },
    eldrop(e) {
      this.$emit("event", {
        fn: "oriDrop",
        params: {
          filterListIndex: this.filterListIndex,
          ...e
        }
      });
    },
    oriChange() {}, // 只是个空壳
    reset(){
      this.initdata.dataList.forEach(item => {
        if (item.children.length > 0) {
          item.children.forEach(_item => {
            _item.isSelect = false
            _item.childShow = false
          })
        }else {
          item.isSelect = false
          item.childShow = false
        }
      })
      this.dataList = []
      this.$emit("event", {
        fn: "reset",
      })
    },
    delSort(index) {
      this.$emit("event", {
        fn: "delSort",
        params: {
          delIndex: index,
          filterListIndex: this.filterListIndex
        }
      });
    },
    showChild (data) {
      if (data.children.length > 0) {
        data.childShow = !data.childShow
      }else {
        return
      }
    },
    //选择服务类型
    selectService (item,index) {
      item.isSelect = !item.isSelect
      if (this.initdata.dataList[index].children.length > 0 && item.children.length==0 && !item.isSelect) {
        this.initdata.dataList[index].isSelect = false
      }
      if (this.initdata.dataList[index].children.length > 0 && item.children.length==0 && item.isSelect) {
        this.initdata.dataList[index].isSelect = true
        this.initdata.dataList[index].children.forEach(res => {
          if (!res.isSelect) {
            this.initdata.dataList[index].isSelect = false
            return
          }
        })
      }
      if (item.children.length > 0) {
        if (item.isSelect) {
          item.childShow = true
          item.children.forEach(data => {
            data.isSelect = true
          })
        }else {
          item.children.forEach(data => {
            data.isSelect = false
          })
        }
      }
      var list = []
      this.initdata.dataList.forEach(item => {
        if (item.children.length > 0) {
          item.children.forEach(child_item => {
            if (child_item.isSelect) {
              list.push(child_item.id)
            }
          })
        }else {
          if (item.isSelect) {
            list.push(item.id)
          }
        }
      })
      this.dataList = list
      this.oriChange()
    },
  },
  components: { drop }
};
</script>
<style scoped lang="less">
@import "./collapse.less";
.sort-label-icon {
  display: inline-block;
  width: 30px;
  height: 30px;
  margin-left: 10px;
}
.add-sort {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #a3a3a3;
  margin-top: 10px;
}
.add-text {
  margin-left: 10px;
  color: #4b4b4b;
  cursor: pointer;
  &:hover {
    color: #d22b2b;
  }
}
.service-list{
  background: #fff;
  border-radius:5px;
  margin-top:5px;
  color:#333;
  padding-left:10px;
  box-shadow: 0px 3px 10px 0px #9f9e9a;
}
.service-li{
  flex-wrap: wrap;
  margin-top:10px;
  align-items: center;
}
.service-child-li{
  margin-top:10px
}
.service-child{
  padding-left:25px;
  width: 100%;
}
.xuan{
  color:#ff7b44;
  font-size:13px;
  margin-right:10px
}
.weixuan{
  color:#ddd;
  font-size:14px;
  margin-right:10px
}
  .select-item{
    justify-content: space-between;
    font-size: 14px;
    width: 88%;
  }
  .select-child-item{
    justify-content: space-between;
    font-size: 14px;
    width: 86.5%;
  }
  .head-pic{
    height: 30px;
    width: 30px;
    margin-right:10px
  }
</style>
